module.exports = function() {
  return new Worker("/" + "download.worker.fc5c34131bfea1d36097.js");
};